var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"160px","height":"192px"}},[_c('window-header',{attrs:{"minimize":false}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.articulo.thumbnail&&_vm.articulo.thumbnail.imagen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }